import { render, staticRenderFns } from "./RadioControl.vue?vue&type=template&id=e63d81c4&scoped=true&"
import script from "./RadioControl.vue?vue&type=script&lang=ts&"
export * from "./RadioControl.vue?vue&type=script&lang=ts&"
import style0 from "./RadioControl.vue?vue&type=style&index=0&id=e63d81c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63d81c4",
  null
  
)

export default component.exports